import type { Chain } from "@suse-o11y/chain";
import type { Defaultable } from "@suse-o11y/defaultable";
import type { Functor } from "@suse-o11y/functor";
import { Matchable } from "@suse-o11y/matchable";

class Failure<TError> extends Matchable<"failure"> implements Functor<never>, Chain<never>, Defaultable<never> {
	protected readonly __name = "failure" as const;

	public constructor(public readonly error: TError) {
		super();
	}

	public isIdle(): false {
		return false;
	}

	public isLoading(): false {
		return false;
	}

	public isFailure(): this is Failure<TError> {
		return true;
	}

	public isSuccess(): false {
		return false;
	}

	public getOrElse<TFallback>(fallback: TFallback): TFallback {
		return fallback;
	}

	public transform(): this {
		return this;
	}

	public transformFailure<TNextError>(transformFailure: (error: TError) => TNextError): Failure<TNextError> {
		return new Failure(transformFailure(this.error));
	}

	public chain(): this {
		return this;
	}
}

export { Failure };
